/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases.newSubCase', {
      url: '/:id/subCase/new',
      template: '<new-sub-case></new-sub-case>',
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/newSubCase/newSubCase.routes.js